import { AxiosGlobalFilters } from '../config';

function getEmpresaId() {
  const value = `; ${document.cookie}`;
  const parts = value.split('; companies=');
  if (parts.length !== 2) return undefined;
  try {
    return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()))?.id;
  } catch {
    return undefined;
  }
}

function headers() {
  const empresaId = getEmpresaId();
  return empresaId ? { EmpresaId: empresaId } : {};
}

export const ComprasService = {
  listar: ({ almoxarifadoId, fornecedorId, status, dataInicial, dataFinal, search, page = 1, pageSize = 10 } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/compras-materiais',
      headers: headers(),
      params: {
        ...(almoxarifadoId && { almoxarifadoId }),
        ...(fornecedorId && { fornecedorId }),
        ...(status !== undefined && { status }),
        ...(dataInicial && { dataInicial }),
        ...(dataFinal && { dataFinal }),
        ...(search && { search }),
        page,
        pageSize,
      },
    }),

  agrupar: ({ compraMaterialIds, almoxarifadoId, status, data }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: '/v1/compras-materiais/agrupamento',
      headers: headers(),
      data: { compraMaterialIds, almoxarifadoId, status, data },
    }),

  criar: ({ almoxarifadoId, status, fornecedorId, data }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: '/v1/compras-materiais',
      headers: headers(),
      data: {
        almoxarifadoId,
        status,
        data,
        ...(fornecedorId && { fornecedorId }),
      },
    }),

  atualizar: ({ id, almoxarifadoId, status, fornecedorId, data }) =>
    AxiosGlobalFilters({
      method: 'PUT',
      url: `/v1/compras-materiais/${id}`,
      headers: headers(),
      data: {
        almoxarifadoId,
        status,
        data,
        ...(fornecedorId && { fornecedorId }),
      },
    }),

  excluir: ({ id }) => AxiosGlobalFilters({ method: 'DELETE', url: `/v1/compras-materiais/${id}`, headers: headers() }),

  // Itens
  listarItens: ({ id }) =>
    AxiosGlobalFilters({ method: 'GET', url: `/v1/compras-materiais/${id}/itens`, headers: headers() }),

  adicionarItem: ({ id, materialId, quantidade, valorUnitario, inseridoPorSolicitacao = false, numeroNotaFiscal }) =>
    AxiosGlobalFilters({
      method: 'POST',
      url: `/v1/compras-materiais/${id}/itens`,
      headers: headers(),
      data: {
        materialId,
        quantidade,
        valorUnitario,
        inseridoPorSolicitacao,
        ...(numeroNotaFiscal && { numeroNotaFiscal }),
      },
    }),

  atualizarItem: ({ id, itemId, quantidade, valorUnitario, numeroNotaFiscal }) =>
    AxiosGlobalFilters({
      method: 'PUT',
      url: `/v1/compras-materiais/${id}/itens/${itemId}`,
      headers: headers(),
      data: {
        quantidade,
        valorUnitario,
        ...(numeroNotaFiscal !== undefined && { numeroNotaFiscal }),
      },
    }),

  excluirItem: ({ id, itemId }) =>
    AxiosGlobalFilters({
      method: 'DELETE',
      url: `/v1/compras-materiais/${id}/itens/${itemId}`,
      headers: headers(),
    }),

  listarSolicitacoesVinculadas: ({ id }) =>
    AxiosGlobalFilters({ method: 'GET', url: `/v1/compras-materiais/${id}/solicitacoes`, headers: headers() }),
};
